import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-list-wrap" }

import Individual_Items from "@/views/instruction/Individual_Items.vue";
import BoardNavbar from "@/views/instruction/Navbar.vue";
import Banner from "@/components/Banner.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Individual',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "개인 이용안내",
      subtitle: "개인 이용안내",
      description: ""
    }),
    _createVNode(BoardNavbar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "sub_subject" }, "개인 이용안내", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Individual_Items)
        ])
      ])
    ])
  ]))
}
}

})